import { Mail } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';
import { ExcludeSendersForm } from './exclude-senders-form';

type ExcludeSendersSettingsContentProps = {
  isLoading: boolean;
  excludedSenders: string[];
  onSubmit: (excludedSenders: string[]) => Promise<void>;
};

export const ExcludeSendersSettingsContent = ({
  isLoading,
  excludedSenders,
  onSubmit,
}: ExcludeSendersSettingsContentProps) => {
  const [isEditing, setIsEditing] = useState(false);

  if (!isEditing) {
    const excludedSendersText =
      excludedSenders.length > 0 ? `${excludedSenders.length} excluded senders` : 'No excluded senders';

    return (
      <Stack space={2} align="stretch">
        <Stack space={1} align="stretch">
          <Inline justify="between">
            <h3 className="text-lg leading-6 font-medium tracking-tight text-black">Exclude senders</h3>

            <Button variant="secondary" onClick={() => setIsEditing(true)}>
              Edit
            </Button>
          </Inline>

          <p className="text-sm leading-6 font-medium tracking-tight text-muted-foreground">
            Here is the list of senders that Seapoint shouldn't automatically pull invoices from.
          </p>
        </Stack>

        <Inline space={1.5} className="h-[57px]">
          <Mail strokeWidth={1} size={16} />

          <p className="text-xs leading-6 font-medium tracking-tight text-black">{excludedSendersText}</p>
        </Inline>
      </Stack>
    );
  }

  return (
    <ExcludeSendersForm
      isLoading={isLoading}
      excludedSenders={excludedSenders}
      onSubmit={async (excludedSenders) => {
        setIsEditing(false);

        await onSubmit(excludedSenders);
      }}
      onCancel={() => setIsEditing(false)}
    />
  );
};
